export default __webpack_public_path__ + "static/media/visa.4dfd4178.svg";